import axios from 'axios';

const client = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_SECURITY_API_ROOT,
    responseType: 'json'
});

export default client;
